import data from '../../helpers/data.json'
import axiosNew, { getAuthorizationHeader, getBackendBaseUrl } from '../../helpers/axios'


// LIST TASKS (SUPPORT API)
export const listTaskSupport = (payload = {}) => {
    const {
        skip = 0,
        limit = 10,
        filter,
        listType = 'status',
        search = '',
    } = payload
    return new Promise(async (resolve) => {
        try {
            const data = {
                skip,
                limit,
                filter,
                listType: listType,
            }

            if (search?.length > 0) {
                data['search'] = {
                    title: search,
                }
            }

            const tasks = await axiosNew({
                url: 'support/task/list',
                method: 'POST',
                data,
            })

            resolve({
                data: tasks?.data?.data ?? [],
                isNext: tasks?.data?.isNext ?? false,
            })
        } catch (error) {
            resolve({
                data: [],
                isNext: false,
            })
        }
    })
}

export const getTasksList = (search) => {
    return new Promise((resolve) => {
        let tasks = data.tasks
        if (search?.length > 0) {
            tasks = tasks.filter((x) =>
                x.name.toLowerCase().includes(search.toLowerCase())
            )
        }
        setTimeout(() => resolve({ data: tasks }), 300)
    })
}

export const getTasksCount = (search) => {
    let tasks = data.tasks
    if (search?.length > 0) {
        tasks = tasks.filter((x) =>
            x.name.toLowerCase().includes(search.toLowerCase())
        )
    }
    return new Promise((resolve) => {
        setTimeout(() => resolve({ data: tasks.length }), 200)
    })
}

// LIST TASKS
export const listTask = (payload) => {
    const {
        skip = 0,
        limit = 0,
        filter,
        search = '',
        listType = 'status',
    } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                limit,
                filter,
                listType: listType,
            }
            if (search?.length > 0) {
                data['search'] = {
                    title: search,
                }
            }
            const tasks = await axiosNew({
                url: 'tasks/list',
                data,
            })
            resolve({ data: tasks?.data?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// LIST SUB TASKS
export const listSubTasks = (payload) => {
    const { skip = 0, limit = 0, parentId } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                limit,
                parentId,
                // filter,
                // listType: 'status',
            }

            const tasks = await axiosNew({
                url: 'tasks/list-child',
                data,
            })
            resolve({ data: tasks?.data?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// LIST SUB TASKS (SUPPORT API)
export const listSubTasksSupport = (payload) => {
    const { skip = 0, limit = 0, parentId } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                limit,
                parentId,
            }

            const tasks = await axiosNew({
                url: '/support/task/child-list',
                method: 'POST',
                data,
            })
            resolve({ data: tasks?.data?.data ?? [] })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// LIST SUB TASKS (MAIN / DEVELOPMENT API)
export const listSubTasksMain = (payload) => {
    const { skip = 0, limit = 0, parentId } = payload
    return new Promise(async (resolve) => {
        try {
            const data = {
                skip,
                limit,
                parentId,
            }

            const tasks = await axiosNew({
                url: 'support/main-task/child-list',
                method: 'POST',
                data,
            })
            resolve({
                data:
                    tasks?.data?.data ??
                    tasks?.data?.result ??
                    [],
            })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// CREATE TASK
export const createTask = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const create = await axiosNew({
                url: 'tasks/create',
                data,
            })
            resolve({ data: create?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TASK (SUPPORT API)
export const createTaskSupport = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const create = await axiosNew({
                url: 'support/task',
                method: 'POST',
                data,
            })
            resolve({ data: create?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TASK (SUPPORT API)
export const updateTaskSupport = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.updateTask ?? {}
            const update = await axiosNew({
                url: `support/task/${payload._id}`,
                method: 'PUT',
                data,
            })
            resolve({ data: update?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TASK
export const updateTask = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.updateTask ?? {}
            const update = await axiosNew({
                url: 'tasks/update/' + payload._id,
                data,
                method: 'put',
            })
            resolve({ data: update?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CHANGE SWIMLANES
export const changeSwimLanes = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const changeSwimlane = await axiosNew({
                url: 'tasks/changes-swimlanes',
                data,
                method: 'put',
            })
            resolve({ data: changeSwimlane?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE TASK
export const deleteTask = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const deleteTask = await axiosNew({
                url: 'tasks/delete/' + payload,
                method: 'delete',
            })
            resolve({ data: deleteTask?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE TASK (SUPPORT API)
export const deleteTaskSupport = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const deleteTask = await axiosNew({
                url: `support/task/${payload}`,
                method: 'DELETE',
            })
            resolve({ data: deleteTask?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TASK BY ID
export const getTaskById = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const getTask = await axiosNew({
                url: 'support/task/' + payload._id,
                method: 'get',
            })
            resolve({ data: getTask?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// start and stop timer
export const startStopTimer = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.data ?? {}
            const startStopRes = await axiosNew({
                url: 'tasks/start-end-timer/' + payload.id,
                data,
                method: 'put',
            })
            resolve({ data: startStopRes.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD / REMOVE COMMENTS
export const addRemoveComments = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.data ?? {}
            const addRemoveComments = await axiosNew({
                url: 'support/task/add-remove-comments/' + payload.id,
                data,
                method: 'put',
            })
            resolve({ data: addRemoveComments.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const addRemoveMainTaskComments = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const data = payload?.data ?? {}
            const response = await axiosNew({
                url: `support/main-task/${payload.id}/comments`,
                data,
                method: 'put',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD / REMOVE ATTACHMENTS
export const addRemoveAttachments = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.data ?? {}
            const addRemoveAttachments = await axiosNew({
                url: 'tasks/add-remove-attachment/' + payload.id,
                data,
                method: 'put',
            })
            resolve({ data: addRemoveAttachments.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD / REMOVE ATTACHMENTS (SUPPORT API)
export const addRemoveAttachmentsSupport = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload?.data ?? {}
            const addRemoveAttachments = await axiosNew({
                url: 'support/task/add-remove-attachment/' + payload.id,
                data,
                method: 'put',
            })
            resolve({ data: addRemoveAttachments.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
// ADD / REMOVE ATTACHMENTS
export const taskHistory = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const taskHistoryData = await axiosNew({
                url: `support/task/history/${id}`,
                method: 'get',
            })
            resolve({ data: taskHistoryData.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const mainTaskHistory = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const taskHistoryData = await axiosNew({
                url: `support/main-task/history/${id}`,
                method: 'get',
            })
            resolve({ data: taskHistoryData.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// Get AWS S3 URL for attachments
export const getS3Url = async (payload) => {
    const data = payload ?? {}
    try {
        const response = await fetch(
            `${getBackendBaseUrl()}/support/upload-file`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Authorization: getAuthorizationHeader(),
                },
                credentials: 'include',
                body: JSON.stringify(data),
            }
        )

        const json = await response.json().catch(() => ({}))
        return { data: json }
    } catch (error) {
        return { data: error?.response?.data ?? {} }
    }
}
// Upload attachment to AWS S3
export const uploadAttachmentToAWS = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            let { data = {}, url = '' } = payload ?? {}
            const attachmentData = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': data.type,
                },
                body: data,
            })
            resolve({ data: attachmentData ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// IMPORT EXCEL TASKS
export const importExcelTasks = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const { file, projectId } = payload
            const formData = new FormData()
            formData.append('upload', file)
            formData.append('projectId', projectId)

            const response = await axiosNew({
                url: 'support/task/import-excel',
                method: 'post',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

/** Normalize main-task list API payload into support-style swimlane groups. */
export const normalizeMainTaskListResponse = (raw) => {
    const arr = (() => {
        if (Array.isArray(raw)) return raw
        if (Array.isArray(raw?.data)) return raw.data
        if (Array.isArray(raw?.tasks)) return raw.tasks
        if (Array.isArray(raw?.results)) return raw.results
        if (Array.isArray(raw?.list)) return raw.list
        return []
    })()
    if (!arr.length) return []
    if (arr[0]?.list) return arr
    const byStatus = new Map()
    let order = 0
    for (const task of arr) {
        const key = task?.status != null ? String(task.status) : 'Uncategorized'
        if (!byStatus.has(key)) {
            byStatus.set(key, {
                _id: key,
                name: key,
                position: order++,
                list: [],
            })
        }
        byStatus.get(key).list.push(task)
    }
    return [...byStatus.values()].map((g, idx) => ({
        ...g,
        position: idx,
        list: [...(g.list || [])].sort(
            (a, b) => Number(a?.position ?? 0) - Number(b?.position ?? 0)
        ),
    }))
}

/** Map ProjectTaskToolbar filter state to main-task / sprint list API filter. */
export const buildTaskToolbarApiFilter = (toolbarFilter = {}) => {
    const selectedAssignees = Array.isArray(toolbarFilter.selectedAssignees)
        ? toolbarFilter.selectedAssignees
        : []
    const selectedStatus = Array.isArray(toolbarFilter.selectedStatus)
        ? toolbarFilter.selectedStatus
        : []
    const hasUnassigned = selectedAssignees.includes('UNASSIGNED')
    const assigneeIds = selectedAssignees.filter((id) => id !== 'UNASSIGNED')
    const assignee =
        toolbarFilter.mineAssignee ||
        (assigneeIds.length > 0 ? assigneeIds : undefined)

    const apiFilter = {}

    if (hasUnassigned) {
        apiFilter.isUnassigned = true
    } else if (assignee?.length) {
        apiFilter.assignee = assignee
        apiFilter.isUnassigned = false
    }

    if (selectedStatus.length === 1) {
        apiFilter.status = selectedStatus[0]
    } else if (selectedStatus.length > 1) {
        apiFilter.status = selectedStatus
    }

    if (typeof toolbarFilter.isCompleted === 'boolean') {
        apiFilter.isCompleted = toolbarFilter.isCompleted
    }

    if (toolbarFilter.type) apiFilter.type = toolbarFilter.type
    if (toolbarFilter.priority) apiFilter.priority = toolbarFilter.priority
    if (toolbarFilter.epic) apiFilter.epic = toolbarFilter.epic

    return apiFilter
}

export const buildMainTaskListRequest = ({
    projectId,
    toolbarFilter = {},
    search = '',
    skip = 0,
    limit = 10,
    sort = { field: 'created', order: 'desc' },
    listType = 'status',
} = {}) => {
    const filter = buildTaskToolbarApiFilter(toolbarFilter)
    const term = String(search ?? '').trim()
    const payload = {
        projectId,
        skip,
        limit,
        sort,
        listType,
    }
    if (term) payload.search = term
    if (Object.keys(filter).length > 0) payload.filter = filter
    return payload
}

export const buildDevelopmentSprintListQuery = (toolbarFilter = {}) => {
    const term = String(toolbarFilter.search ?? '').trim()
    const filter = buildTaskToolbarApiFilter(toolbarFilter)
    const query = {
        sort: { field: 'createdAt', order: 'desc' },
    }
    if (term) query.search = term
    if (Object.keys(filter).length > 0) query.filter = filter
    return query
}

export const listMainTasks = (payload = {}) => {
    const {
        projectId,
        skip = 0,
        limit = 20,
        sort = { field: 'created', order: 'desc' },
        listType = 'status',
        search = '',
        filter,
    } = payload
    return new Promise(async (resolve) => {
        try {
            const data = {
                projectId,
                skip,
                limit,
                sort,
                listType,
            }

            if (search?.length > 0) {
                data['search'] = {
                    title: search,
                }
            }

            if (filter && Object.keys(filter).length > 0) {
                data.filter = filter
            }

            const res = await axiosNew({
                url: 'support/main-task/list',
                method: 'POST',
                data,
            })
            const body = res?.data ?? {}
            const raw = body?.data ?? body?.tasks ?? body?.results ?? body
            const normalized = normalizeMainTaskListResponse(raw)
            resolve({
                data: normalized,
                isNext: body?.isNext ?? false,
            })
        } catch (error) {
            resolve({ data: [], isNext: false })
        }
    })
}

export const getMainTaskById = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: `support/main-task/${id}`,
                method: 'GET',
            })
            resolve({ data: res?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const createMainTask = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const create = await axiosNew({
                url: 'support/main-task',
                method: 'POST',
                data: payload ?? {},
            })
            resolve({ data: create?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const updateMainTask = async ({ id, body }) => {
    return new Promise(async (resolve) => {
        try {
            const update = await axiosNew({
                url: `support/main-task/${id}`,
                method: 'PUT',
                data: body ?? {},
            })
            resolve({ data: update?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const deleteMainTask = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const del = await axiosNew({
                url: `support/main-task/${id}`,
                method: 'DELETE',
            })
            resolve({ data: del?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

/** API expects id strings; GET may return populated { _id, name, ... } objects */
export const resolveReferenceId = (value) => {
    if (value == null || value === '') return null
    if (typeof value === 'string') return value
    if (typeof value === 'number') return String(value)
    if (Array.isArray(value)) {
        if (value.length === 0) return null
        return resolveReferenceId(value[0])
    }
    if (typeof value === 'object') {
        const id = value._id ?? value.id
        if (id != null && id !== '') return String(id)
    }
    return null
}

export const buildMainTaskUpdateBodyFromTask = (
    task,
    _projectId,
    overrides = {}
) => {
    if (!task) return {}
    const assigneeFromTask = () => resolveReferenceId(task.assigneeId)
    const refFromTask = (key, altKey) => {
        const raw =
            task[altKey] !== undefined ? (task[key] ?? task[altKey]) : task[key]
        return resolveReferenceId(raw)
    }
    const body = {
        title: overrides.title ?? task.title,
        description:
            overrides.description !== undefined
                ? overrides.description
                : (task.description ?? ''),
        status: overrides.status ?? task.status,
        type: overrides.type ?? task.type ?? 'Task',
        priority: overrides.priority ?? task.priority ?? 'Low',
        estimation: overrides.estimation ?? task.estimation ?? 0,
        progress: overrides.progress ?? task.progress ?? 0,
        assigneeId:
            overrides.assigneeId !== undefined
                ? overrides.assigneeId
                : assigneeFromTask(),
        reporterId:
            overrides.reporterId !== undefined
                ? resolveReferenceId(overrides.reporterId)
                : refFromTask('reporterId'),
        sprintId:
            overrides.sprintId !== undefined
                ? resolveReferenceId(overrides.sprintId)
                : refFromTask('sprintId'),
        epic:
            overrides.epic !== undefined
                ? resolveReferenceId(overrides.epic)
                : refFromTask('epic', 'epicId'),
        parent:
            overrides.parent !== undefined
                ? resolveReferenceId(overrides.parent)
                : refFromTask('parent'),
        start:
            overrides.start !== undefined
                ? overrides.start
                : (task.start ?? null),
        end: overrides.end !== undefined ? overrides.end : (task.end ?? null),
        attachment:
            overrides.attachment !== undefined
                ? overrides.attachment
                : (task.attachment ?? []),
        initialPosition: overrides.initialPosition,
        position: overrides.position,
    }
    Object.keys(body).forEach((k) => {
        if (body[k] === undefined) delete body[k]
    })
    return body
}

export const isTaskMutationSuccess = (data) => {
    if (!data || data.success === false) return false
    if (data.success === true) return true
    if (data._id) return true
    if (data.data?._id) return true
    if (data.data?.success === true) return true
    return false
}
